<template>
  <div class="m-card-primary m-the-modal-content">
    <form
      autocomplete="off"
      name="the-modal-form"
      @submit.prevent="$modal.closeModal"
    >
      <header class="m-the-modal-header">
        <h5>{{ $t('mEditionBillingPaymentMethodsModalConfigurationData.title') }}</h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p class="font-size-large font-weight-bold text-transform-capitalize">
          <span :class="$modal.element.activa ? 'text-color-billing-primary' : 'text-color-danger'">
            {{ $modal.element.descripcion }}
          </span>
        </p>
        <ul class="a-list-clean font-size-small margin-top-zero">
          <li
            v-for="(item, index) in $modal.element.configuracion"
            :key="index"
            class="margin-bottom-medium"
          >
            <span class="font-weight-bold text-transform-capitalize">
              {{ `${index}: ` }}
            </span>
            <span>{{ item }}</span>
          </li>
        </ul>
      </section>
      <footer class="m-the-modal-footer">
        <AtomButtonPrimary :button-primary="buttonPrimary"/>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingPaymentMethodsModalConfigurationData',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mEditionBillingPaymentMethodsModalConfigurationData.buttonPrimary'),
        class: 'a-button-billing-primary',
        sending: false,
        type: 'submit'
      }
    }
  }
}
</script>
